const e = { last_updated: "Última actualización", Series_type: "Serie", "How to guide_type": "Guía", FAQ_type: "Predeterminado" }, t = {
  articles: e
};
export {
  e as articles,
  t as default
};
//# sourceMappingURL=help-center-knowledge-anatomies29.js.map
